import type { SxProps, Theme } from "@mui/material/styles";

export * from "../../assets/theme/custom/tokens";

export const appFormFieldSx: SxProps<Theme> = (theme) => theme.custom.form.appFormField;
export const formControlLabelAlignSx: SxProps<Theme> = (theme) => theme.custom.form.formControlLabelAlign;
export const formRowButtonSx: SxProps<Theme> = (theme) => theme.custom.form.formRowButton;
export const chartOptionInputSx: SxProps<Theme> = (theme) => theme.custom.form.chartOptionInput;
export const chartOptionToggleGroupSx: SxProps<Theme> = (theme) => theme.custom.form.chartOptionToggleGroup;
export const chartOptionSectionLabelSx: SxProps<Theme> = (theme) => theme.custom.form.chartOptionSectionLabel;
export const chartOptionFieldLabelSx: SxProps<Theme> = (theme) => theme.custom.form.chartOptionFieldLabel;
export const chartOptionFieldControlBoxSx: SxProps<Theme> = (theme) => theme.custom.form.chartOptionFieldControlBox;
export const chartOptionOutlinedInputSx: SxProps<Theme> = (theme) => theme.custom.form.chartOptionOutlinedInput;
export const chartOptionFormGridSx: SxProps<Theme> = (theme) => theme.custom.form.chartOptionFormGrid;
export const pageSectionPanelSx: SxProps<Theme> = (theme) => theme.custom.form.pageSectionPanel;
export const pageFilterPanelSx: SxProps<Theme> = (theme) => theme.custom.form.pageFilterPanel;
export const pageFilterPanelContentSx: SxProps<Theme> = (theme) => theme.custom.form.pageFilterPanelContent;
export const pageStatCardSx: SxProps<Theme> = (theme) => theme.custom.form.pageStatCard;
export const pageStatCardContentSx: SxProps<Theme> = (theme) => theme.custom.form.pageStatCardContent;
export const pageStatGridSx: SxProps<Theme> = (theme) => theme.custom.form.pageStatGrid;

/** Selected master-list row (OpenAPI catalogs pattern). */
export const pageSelectedRowSx: SxProps<Theme> = {
  cursor: "pointer",
  "&.Mui-selected": {
    bgcolor: "action.selected",
    borderLeft: 3,
    borderColor: "primary.main",
  },
  "&.Mui-selected:hover": {
    bgcolor: "action.selected",
  },
};

/** Clickable mobile list card when selected. */
export const pageSelectedCardSx = (selected: boolean): SxProps<Theme> => ({
  p: 1.5,
  border: 1,
  borderColor: selected ? "primary.main" : "divider",
  borderRadius: 2,
  bgcolor: selected ? "action.selected" : "background.paper",
  cursor: "pointer",
});


export const chartOptionSelectFormProps = {
  formControlProps: { sx: chartOptionInputSx },
} as const;
